/**
 * SolyticsFlow — Constants
 *
 * Central registry for node type keys, edge type keys, edge defaults,
 * and default token-backed colour scheme mappings.
 */

// ── Node type keys (must match the CustomNodeTypes map in Nodes/index.js) ──
export const NODE_TYPES = {
  CARD_NODE: 'cardNode',
  DIAMOND_NODE: 'diamondNode',
  GROUP: 'group',
  CIRCLE_NODE: 'circleNode',
  LIST_NODE: 'listNode',
};

// ── Edge type keys (must match the CustomEdgeTypes map in Edges/index.js) ──
export const EDGE_TYPES = {
  SOLID: 'solid',
  OFFSET: 'offset',
  DASHED: 'dashed',
};

// ── Default edge styling ────────────────────────────────────────────────
export const DEFAULT_EDGE_OPTIONS = {
  style: {
    strokeWidth: 1.5,
  },
};

// ── Default node dimensions ─────────────────────────────────────────────
export const DEFAULT_NODE_WIDTH = 200;
export const DEFAULT_NODE_HEIGHT = 36;

// ── Group node default style ────────────────────────────────────────────
export const DEFAULT_GROUP_STYLE = {
  width: 200,
  height: 250,
  zIndex: -1,
};

// ── Node Color Schemes ──────────────────────────────────────────────────
// These are just defaults. Developers can always override with:
//   data.color / data.bgColor / data.borderColor / data.textColor
// and can use theme-token strings such as "primary.main" or
// "solyticsFlow.node.primaryBg".
export const NODE_COLOR_SCHEMES = {
  default: {
    bg: 'solyticsFlow.node.defaultBg',
    border: 'solyticsFlow.node.defaultBorder',
    text: 'solyticsFlow.node.defaultText',
  },
  primary: {
    bg: 'solyticsFlow.node.primaryBg',
    border: 'solyticsFlow.node.primaryBorder',
    text: 'solyticsFlow.node.primaryText',
  },
  danger: {
    bg: 'solyticsFlow.node.dangerBg',
    border: 'solyticsFlow.node.dangerBorder',
    text: 'solyticsFlow.node.dangerText',
  },
  info: {
    bg: 'solyticsFlow.node.infoBg',
    border: 'solyticsFlow.node.infoBorder',
    text: 'solyticsFlow.node.infoText',
  },
};
